export function customSelect() {
    $(window).on("load", function () {
        if ($("select").length) {
            jcf.setOptions("Select", {
                wrapNative: false,
                flipDropToFit: false,
                fakeDropInBody: false,
                maxVisibleItems: 10
            });

            jcf.replaceAll();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js